import { render } from "./SurveyRouter.vue?vue&type=template&id=0240b29b"
import script from "./SurveyRouter.vue?vue&type=script&lang=ts"
export * from "./SurveyRouter.vue?vue&type=script&lang=ts"
script.render = render

export default script